"use client";

import { Box, Button, Card, Typography, Alert } from "@mui/material";
import { CreditCard as CreditCardIcon, ErrorOutline as ErrorIcon } from "@mui/icons-material";

interface CardErrorProps {
	errorMessage: string;
	onTryAgain: () => void;
}

const CardError = ({ errorMessage, onTryAgain }: CardErrorProps) => {
	return (
		<Card sx={{ p: 3, mb: 3, width: "100%" }}>
			<Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
				<ErrorIcon sx={{ fontSize: 60, color: "#F59E0B", mb: 2 }} />

				<Typography variant="h6" gutterBottom>
					Pagamento não Processado
				</Typography>

				<Alert severity="warning" sx={{ width: "100%", mb: 3 }}>
					{errorMessage}
				</Alert>

				<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
					Isso pode acontecer por diversos motivos. Você pode verificar os dados inseridos ou tentar com outro cartão.
				</Typography>

				<Button variant="contained" color="primary" startIcon={<CreditCardIcon />} onClick={onTryAgain} sx={{ minWidth: 200 }}>
					Tentar com outro cartão
				</Button>
			</Box>
		</Card>
	);
};

export default CardError;
